<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../../../_shared/_logic/rich-tooltips"
  import type { PlanningPreviewRow } from "../../../../../../_shared/_logic/table-contract"

  type Props = {
    row: PlanningPreviewRow
  }

  const { row }: Props = $props()
</script>

<StatusTag
  size="sm"
  label={row.warningTag.label}
  subLabel={row.warningTag.subLabel ?? undefined}
  color={row.warningTag.color}
  icon={row.warningTag.icon ?? undefined}
  tooltipContent={row.warningTag.tooltip ?? ""}
  tooltipHtml={row.warningTag.tooltipHtml ?? false}
  tooltipClassName={RICH_TOOLTIP_CLASS}
  disableTitle={true}
/>
